/**
 * The one place this application reads the wall clock.
 *
 * `no-restricted-syntax` bans `new Date()` everywhere in app code, and the
 * message says why: "use an injected clock rather than new Date() so time is
 * testable and always UTC". This module is that injection point — the single
 * disabled line the rule is asking for, rather than a disable comment beside
 * every component that needs to know what day it is.
 *
 * A component takes a `Clock` and defaults to `systemClock`, so a test can hand
 * it a fixed instant and assert on the rendered date instead of on whatever
 * today happens to be on the machine running CI.
 */
export interface Clock {
  now(): Date;
}

export const systemClock: Clock = {
  // eslint-disable-next-line no-restricted-syntax -- the seam the rule exists to create
  now: () => new Date(),
};

/** A clock stopped at a known instant. For tests, and only for tests. */
export const fixedClock = (at: Date): Clock => ({ now: () => at });
